<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Calabria for kids/Top_Calabria-kids.jpg">
<div class="content">
    <h1>Calabria For Kids</h1>
</div>
</div>
<!-- <br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a class="active">Riserva naturale Valli Cupe</a></p>
</div>
<br> -->
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            La Calabria è una regione con un patrimonio paesaggistico sorprendente che racchiude immensi parchi naturali e oltre 800 km di costa. 
            Un paesaggio che offre tante attività outdoor adatte ai bambini, come ciclopiste, parchi avventura e tante altre possibilità offerte dalle spiagge e dal mare.
            <br>
            <br>
            I Parchi avventura sono numerosi e si trovano in tutte le aree protette della Calabria, dal Pollino alla Sila, 
            dalle Serre all’Aspromonte. Si tratta di infrastrutture collocate in aree di particolare pregio ambientale che offrono ai più piccoli,
             ma non solo, la possibilità di mettersi alla prova in habitat meravigliosi, con alberi monumentali e una vegetazione rigenerante.
            <br>
            <br>
            Tra i principali Parchi avventura si segnalano, da nord a sud: Gioia a Laino Borgo (CS); Parco avventura Lao a Santa Domenica Talao (CS); 
            Plataciland a Plataci (CS); Lupo Ezechiele a Camigliatello Silano (CS); Cuturelle in Sila nella Riserva omonima nel territorio di San Giovanni in Fiore (CS); 
            Loricaly che propone il bob su rotaie e Silavventura, entrambi a a Lorica (CS); Sila Park adventur a Villaggio Palumbo di Cotronei (KR); 
            Parco avventura Principe a Petilia Policastro (Kr); Orme del Parco a Tirivolo (CZ); Parco avventura Alberolandia presso il 
            Park Hotel Granaro di Sorbo San Basile (CZ) dove è disponibile anche una pista di e-kart; Avventure in borgo a Sellia (CZ); 
            il Bosco sospeso a Cenadi (CZ); Parco avventura Adrenalina verde a Serra San Bruno (VV); Aspropark a Bosurgi (RC).
            <br>
            <br>
            A questi si aggiungono i parchi avventura sulla costa, come Sybaris explora a Sibari (CS); Senza limiti Parco acquatico di Cirò Marina; 
            La balena parco divertimenti di Amantea (CS); il Parco Graziella e quello degli Avieri a Reggio Calabria.
            <br>
            <br>
            Numerosi sono i tratti di ciclopista percorribili dai bambini: lungo la Ciclovia dei Parchi della Calabria il 
            percorso da Mormanno a Castrovillari nel Parco del Pollino, in fase di completamento; quelli di Villaggio Mancuso e del lago Ampollino, 
            in Sila. Anche nei comuni della costa sono numerose le infrastrutture disponibili, da Rocca Imperiale (CS), Villapiana Lido (CS), Capo Rizzuto (KR),
             Le Castella - Marinella di Cutro (KR), Soverato (CZ), Roccella Jonica (CZ), Siderno-Locri, Bianco (RC) sullo Jonio; Praia a Mare (CS), 
             Scalea (CS), Santa Maria del Cedro, sul Tirreno, fino a Reggio Calabria che offre un tracciato magnifico che conduce sul Lungomare Falcomatà.
            <br>
            <br>
            Ulteriore attrazione per i bambini è rappresentata dai musei tematici come il Sila Science Park nel territorio di Taverna (CZ) e i 
            Centri visita dei Parchi molto attrezzati per presentare in modalità coinvolgente il patrimonio di biodiversità presente. 
            A questo si aggiunge l’attività didattica svolta dai tanti Musei che connotano paesi e città della Calabria, da quelli archeologici a quelli storici, 
            artistici e delle tradizioni popolari.
            
        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>